export default __webpack_public_path__ + "static/media/opencart.ac63a3e1.svg";